'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* global document */
// eslint-disable-next-line import/prefer-default-export
var getImageUrl = exports.getImageUrl = function getImageUrl() {
    /* copied from deprecated Engage SDK */
    var metaTags = document.getElementsByTagName('meta');
    var imageUrl = null;
    var property = void 0;

    for (var i = 0; i < metaTags.length; i += 1) {
        property = metaTags[i].getAttribute('property');

        if (property === 'og:image') {
            imageUrl = metaTags[i].content;
            break;
        }
    }

    return imageUrl;
};
//# sourceMappingURL=util.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/~/@spp/tracking/lib/cjs/trackers/pulse/view/util.js
 ** module id = 634
 ** module chunks = 1
 **/